import { put, select, takeLatest } from "redux-saga/effects";

import { EntityType } from "@mapmycustomers/shared/enum";

import { updateRecordUsage } from "@app/store/iam/actions";

import { notifyAboutChanges, UiSyncListener } from "./actions";
import { getListeners } from "./selectors";

export function* onNotify({ payload }: ReturnType<typeof notifyAboutChanges>) {
  const allListeners: Partial<Record<EntityType, UiSyncListener[]>> = yield select(getListeners);
  const targetListeners = allListeners[payload.entityType] ?? [];
  if (!targetListeners.length) {
    return;
  }

  if ([EntityType.COMPANY, EntityType.DEAL, EntityType.PERSON].includes(payload.entityType)) {
    const diff = (payload.added?.length ?? 0) - (payload.deletedIds?.length ?? 0);
    if (diff !== 0) {
      yield put(updateRecordUsage(diff));
    }
  }

  targetListeners.forEach((listener) => {
    if (payload.added) {
      listener.onAdd?.(payload.entityType, payload.added);
    }
    if (payload.updated || payload.updatedIds) {
      listener.onUpdate?.(
        payload.entityType,
        payload.updated ?? [],
        payload.possiblyOtherRecordsAffected
      );
    }
    if (payload.deletedIds) {
      listener.onDelete?.(payload.entityType, payload.deletedIds);
    }
    if (payload.restored) {
      listener.onRestore?.(payload.entityType, payload.restored);
    }
  });
}

export function* uiSyncSaga() {
  yield takeLatest(notifyAboutChanges, onNotify);
}
